import React, { useEffect, useState } from "react";
import { RSelect } from "../Component";
import { locationDropdownData } from "./DropDownData";
import { useDispatch, useSelector } from "react-redux";
import { PermissionType } from "./PermissionDropdown";
import { setCurrentLocation, setAllLocations } from "../../store/authSlice";

export const LocationDropDown = ({
  value,
  isMulti = false,
  onSelect,
  selectedId,
  isLoadList = true,
  placeholder,
  disabled,
  showAllLocations = false,
  ...props
}) => {
  const dispatch = useDispatch();
  const sessionUser = useSelector((state) => state?.auth?.sessionUser);
  const location = useSelector((state) => state?.auth?.currentLocation);
  const userType = sessionUser?.userType;

  const [list, setList] = useState();

  useEffect(() => {
    onSelect(location);
  }, [location]);

  useEffect(() => {
    if (
      (userType === PermissionType.admin ||
        userType === PermissionType.manager) &&
      isLoadList
    ) {
      loadLocationList();
    } else if (userType === PermissionType.staff) {
      onSelect(location);
    }
  }, []);

  const loadLocationList = () => {
    locationDropdownData((data, error) => {
      if (error === null) {
        let updatedList = [...data];
        let allLocationsOption = null;
        
        // Only add Head Office option for admin users
        if (userType === PermissionType.admin) {
          allLocationsOption = {
            id: 'head-office',
            label: 'Head Office',
            value: 'Head Office',
          };
          updatedList = [allLocationsOption, ...data];
        }
        
        setList(updatedList);
        
        if (showAllLocations && userType === PermissionType.admin && allLocationsOption) {
          dispatch(setCurrentLocation(allLocationsOption));
          dispatch(setAllLocations(true));
        } else if (data && data.length > 0) {
          dispatch(setCurrentLocation(data[0]));
          dispatch(setAllLocations(false));
        }
      }
    });
  };

  useEffect(() => {
    if (selectedId) {
      const selectedOption = list.find((option) => option.id === selectedId);
      if (selectedOption) {
        // onSelect(selectedOption);
        dispatch(setCurrentLocation(selectedOption));
      }
    }
  }, [list]);

  useEffect(() => {
    if (list && list.length > 0) {
      if (showAllLocations && !location && userType === PermissionType.admin) {
        // Only set "All Locations" if no location is currently selected and user is admin
        const allLocationsOption = list.find(option => option.id === 'head-office');
        if (allLocationsOption) {
          dispatch(setCurrentLocation(allLocationsOption));
          dispatch(setAllLocations(true));
        }
      } else if (!showAllLocations && location && location.id === 'head-office') {
        // If showAllLocations is false but "All Locations" is selected, switch to first actual location
        const firstActualLocation = list.find(option => option.id !== 'head-office');
        if (firstActualLocation) {
          dispatch(setCurrentLocation(firstActualLocation));
          dispatch(setAllLocations(false));
        }
      }
    }
  }, [showAllLocations, list, userType]);

  const filteredOptions = list ? list.filter(option => {
    if (showAllLocations) {
      return true;
    } else {
      // Only show Head Office option for admin users, otherwise filter it out
      if (option.id === 'head-office') {
        return userType === PermissionType.admin;
      }
      return true;
    }
  }) : [];

  return (
    <RSelect
      options={filteredOptions}
      isMulti={isMulti}
      placeholder={placeholder}
      isDisabled={userType === PermissionType.staff || disabled}
      value={value ?? location}
      onChange={(e) => {
        if (e && e.id === 'head-office' && showAllLocations && userType === PermissionType.admin) {
          dispatch(setCurrentLocation(e));
          dispatch(setAllLocations(true));
        } else if (e && e.id !== 'head-office') {
          dispatch(setCurrentLocation(e));
          dispatch(setAllLocations(false));
        }
      }}
      {...props}
    />
  );
};
